import type { AssignmentPatch } from '@/shared/api';
import type { Assignment, Legs, Outcome } from '@/shared/types';

/**
 * Applying one edit to an assignment row.
 *
 * Shared by the Worker and the browser on purpose: the client renders the
 * result optimistically before the write lands, and if the two implementations
 * disagreed the UI would visibly flinch when the server response arrived.
 */

export function blankAssignmentRow(date: string, riderId: string): Assignment {
  return {
    date,
    riderId,
    volunteerId: null,
    confirmed: false,
    outcome: 'Pending',
    legs: 'Both',
    manual: false,
    publicEventId: null,
    inviteEventId: null,
    notes: '',
  };
}

export function applyAssignmentPatch(base: Assignment, patch: AssignmentPatch): Assignment {
  const changesVolunteer =
    patch.volunteerId !== undefined && patch.volunteerId !== base.volunteerId;

  return {
    ...base,
    volunteerId: patch.volunteerId !== undefined ? patch.volunteerId : base.volunteerId,
    confirmed: patch.confirmed ?? base.confirmed,
    outcome: (patch.outcome as Outcome | undefined) ?? base.outcome,
    legs: (patch.legs as Legs | undefined) ?? base.legs,
    notes: patch.notes ?? base.notes,
    // Hand-picking a volunteer marks the row Manual, which is what stops the
    // next regenerate from quietly undoing the coordinator's decision.
    manual: patch.manual ?? (changesVolunteer ? true : base.manual),
  };
}
